(function () {
    "use strict";


    // @ngInject

    function SetupGuideServiceCtor(UiPersistenceService, PubSubService, OnboardingService, EventService, TemplatesViewService, NavigationService,
                                   AppStates, $state, $window, JsSlicklightboxService, _, $q, AnalyticsService, PopupMessageService,
                                   UsersManager, FeaturesService, UserService, OnboardingBotManager, CompaniesManager, AbTestService, Enums,
                                   ModalService, $translate, $timeout, DeviceService, WorkspaceFileService, WorkspacesManager, moment, CompanyService, TemplatesManager, SelfOnboardingManager) {

        this.UiPersistenceService = UiPersistenceService;
        this.AbTestService = AbTestService;
        this.Enums = Enums;

        PubSubService.ventMyBitchUp(this);
        this.OnboardingService = OnboardingService;
        this.EventService = EventService;
        this.TemplatesViewService = TemplatesViewService;
        this.AppStates = AppStates;
        this.$state = $state;
        this.$window = $window;
        this.ModalService = ModalService;
        this.$translate = $translate;
        this.PopupMessageService = PopupMessageService;
        this.STEP_COMPLETED_EVENT_NAME = "setupGuideStepCompleted";
        this.JsSlicklightboxService = JsSlicklightboxService;
        this._ = _;
        this.$timeout = $timeout;
        this.$q = $q;
        this.AnalyticsService = AnalyticsService;
        this.PopupMessageService = PopupMessageService;
        this.UsersManager = UsersManager;
        this.FeaturesService = FeaturesService;
        this.UserService = UserService;
        this.OnboardingBotManager = OnboardingBotManager;
        this.DeviceService = DeviceService;
        this.WorkspaceFileService = WorkspaceFileService;
        this.CompaniesManager = CompaniesManager;
        this.WorkspacesManager = WorkspacesManager;
        this.NavigationService = NavigationService;
        this.moment = moment;
        this.CompanyService = CompanyService;
        this.TemplatesManager = TemplatesManager;
        this.SelfOnboardingManager = SelfOnboardingManager;

        this.currUser = UsersManager.getCurrUser();
        this.company = this.CompaniesManager.getCurrCompany();
        this.setupGuideVersionNames = {
            v1: "setup_guide_page",
            v2: "setup_guide_modal",
            v3: "setup_guide_streamlined",
            v4: "setup_guide_home"
        };

        this.setupGuideStats = {
            completion: 0
        };

        this.demo_assets = [
            "https://res.cloudinary.com/honeybook/image/upload/dpr_auto,q_auto/v1517476087/onboarding/demo/01_pipeline.png",
            "https://res.cloudinary.com/honeybook/image/upload/dpr_auto,q_auto/v1517476087/onboarding/demo/02_workspace_activity.png",
            "https://res.cloudinary.com/honeybook/image/upload/dpr_auto,q_auto/v1517476087/onboarding/demo/03_workspace_files.png",
            "https://res.cloudinary.com/honeybook/image/upload/dpr_auto,q_auto/v1517476087/onboarding/demo/04_invoice.png",
            "https://res.cloudinary.com/honeybook/image/upload/dpr_auto,q_auto/v1517476087/onboarding/demo/05_agreements.png",
            "https://res.cloudinary.com/honeybook/image/upload/dpr_auto,q_auto/v1517476087/onboarding/demo/06_bookkeping.png",
            "https://res.cloudinary.com/honeybook/image/upload/dpr_auto,q_auto/v1517476087/onboarding/demo/07_workflows.png",
            "https://res.cloudinary.com/honeybook/image/upload/dpr_auto,q_auto/v1517476087/onboarding/demo/08_tasks.png"
        ];
        this.galleryInitialized = false;
        this.lightboxContainer = '#demo-account-gallery';
        this._subscriptionPercent = 1;

        this.initializeSetupGuideService();

        this.UsersManager.on('loggingIn', this.initializeSetupGuideService.bind(this));
        this.OnboardingService.on('onboardingAdded', this.initializeSetupGuideService.bind(this));
        this.EventService.on('userCreatedProject', this.completeCreateProjectTask.bind(this));

        CompanyService.on(this.Enums.PubSubTriggers.companyBrandingUpdated, this.checkIfCompanyHasLogo.bind(this));

    }

    Services.SetupGuideService = Class(function () {
        return {
            constructor: SetupGuideServiceCtor,

            onTopNavSetupGuideButtonClick: function onTopNavSetupGuideButtonClick() {
                this.stopAnimateSetupGuideTopNavAfterClose();
                this.$state.go(
                    this.OnboardingService.getSetupGuideState(),
                    { openOnboardingCard: true }
                );

                // This clears the parameter so that repeated SetupGuideButton clicks
                // will reopen the streamlined card
                this.$timeout(function () {
                    this.$state.params.openOnboardingCard = null;
                }.bind(this), 100);
            },

            completedDonut: function completedDonut() {
                var completedDonutPercentage = this.setupGuideStats.completion / 100;

                // donut is always obviously incomplete if under 100%
                if (completedDonutPercentage < 1 && completedDonutPercentage >= 0.945) {
                    return 0.92;
                } else {
                    return completedDonutPercentage;
                }
            },

            getInteractiveResources: function getInteractiveResources() {
                this._setupGuideRawData = {
                    customizeItems: {

                        videoTutorials: {
                            ignoreInCalc: true,
                            disableOnMobile: false,
                            title: 'INTERACTIVE_ONBOARDING.RESOURCES.VIDEO_TUTORIALS._TITLE_',
                            image: '//res.cloudinary.com/honeybook/image/upload/v1527168848/app/setup_guide_modal/setup-full-account.svg',
                            externalLink: 'https://www.youtube.com/playlist?list=PL6TUvBzCkmeXaqKG62m8bUhQ1puQA3Fna',
                            clickHandler: function clickHandler() {
                                this.AnalyticsService.trackClick(
                                    this,
                                    "setup guide task",
                                    {
                                        setup_task: "video tutorials",
                                        source: "setup guide",
                                    }
                                );
                            }.bind(this)
                        },

                        webinars: {
                            ignoreInCalc: true,
                            disableOnMobile: false,
                            title: 'INTERACTIVE_ONBOARDING.RESOURCES.WEBINARS._TITLE_',
                            image: '//res.cloudinary.com/honeybook/image/upload/v1527168848/app/setup_guide_modal/setup-full-account.svg',
                            externalLink: 'https://help.honeybook.com/en/articles/3335484-on-demand-product-webinars',
                            clickHandler: function clickHandler() {
                                this.AnalyticsService.trackClick(
                                    this,
                                    "setup guide task",
                                    {
                                        setup_task: "webinars",
                                        source: "setup guide",
                                    }
                                );
                            }.bind(this)
                        },

                        accountSetup: {
                            ignoreInCalc: true,
                            disableOnMobile: false,
                            title: 'ONBOARDING.SETUP_GUIDE_STREAMLINED.SECONDARY_CONTENT._ACCOUNT_SETUP_',
                            clickHandler: function clickHandler() {
                                this.$state.go(this.AppStates.root_core_accountSetup)
                                this.AnalyticsService.trackClick(
                                    this,
                                    "setup guide task",
                                    {
                                        setup_task: "accountSetup",
                                        source: "setup guide",
                                    }
                                );
                            }.bind(this)
                        },

                    }
                }

                var stepsArray = this._.map(this._setupGuideRawData, function (list, listKey) {
                    return this._.map(list, function (item, itemKey) {
                        var clonedItem = this._.clone(item);
                        return this._.extend(clonedItem, {
                            key: itemKey,
                            listKey: listKey,
                            isComplete: false,
                            isLoading: false,
                        })
                    }.bind(this))
                }.bind(this));

                var concatedArrays = [];
                this._.each(stepsArray, function (array) {
                    concatedArrays = concatedArrays.concat(array);
                });
                return concatedArrays;
            },

            getSetupGuideStreamlinedSteps: function getSetupGuideStreamlinedSteps() {
                this._subscriptionPercent = 9;
                // _setupGuideRawData - the data the be shown on each item. separated to 2 lists.
                // the list later will be merged into one big array so please maintain a unique key for both lists.
                this._setupGuideRawData = {

                    headerItems: {

                        becomeMember: {
                            ignoreInCalc: true, //because we add an empty state in calc. consider removing the addition and not ignoring this.
                            closeSetupGuideOnClick: true,
                            fixedOrder: 1,
                            orderStreamlined: 6,
                            disableOnMobile: false,
                            headline: 'ONBOARDING.SETUP_GUIDE_STREAMLINED.MAIN_CONTENT.BECOME_MEMBER._HEADLINE_',
                            bodyCopy: 'ONBOARDING.SETUP_GUIDE_STREAMLINED.MAIN_CONTENT.BECOME_MEMBER._BODY_COPY_',
                            ctaText: 'ONBOARDING.SETUP_GUIDE_STREAMLINED.MAIN_CONTENT.BECOME_MEMBER._CTA_',
                            secondaryCtaText: 'ONBOARDING.SETUP_GUIDE_STREAMLINED.MAIN_CONTENT.BECOME_MEMBER._SECONDARY_CTA_',
                            graphicUrl: 'https://res.cloudinary.com/honeybook/image/upload/v1551468132/app/setup_guide_modal/trophy_illustration.svg',
                            homeCardGraphicUrl: 'https://res.cloudinary.com/honeybook/image/upload/v1557338114/system_web/home/streamlined-subscribe.svg',
                            // secondaryCtaText: 'ONBOARDING.SETUP_GUIDE_STREAMLINED.MAIN_CONTENT.BECOME_MEMBER._SECONDARY_CTA_',
                            clickHandler: function clickHandler() {
                                this.$state.go(this.AppStates.root_core_navigation_settings_company_subscription);
                            }.bind(this),
                            secondaryClickHandler: function secondaryClickHandler() {
                                this.AnalyticsService.trackClick(
                                    this,
                                    "setup guide modal task",
                                    {
                                        setup_task: "accountSetup",
                                        setup_guide_variant: this.setupGuideType,
                                        cta_location: "pricing",
                                    });
                                this.$state.go(this.AppStates.root_core_accountSetup);
                            }.bind(this),
                        },

                        createProject: {
                            closeSetupGuideOnClick: true,
                            disableAutoCompleteTask: true,
                            disableOnMobile: false,
                            orderStreamlined: 5,
                            headline: 'ONBOARDING.SETUP_GUIDE_STREAMLINED.MAIN_CONTENT.CREATE_PROJECT._HEADLINE_',
                            bodyCopy: 'ONBOARDING.SETUP_GUIDE_STREAMLINED.MAIN_CONTENT.CREATE_PROJECT._BODY_COPY_',
                            ctaText: 'ONBOARDING.SETUP_GUIDE_STREAMLINED.MAIN_CONTENT.CREATE_PROJECT._CTA_',
                            graphicUrl: 'https://res.cloudinary.com/honeybook/image/upload/v1551468132/app/setup_guide_modal/awesome_illustration.svg',
                            homeCardGraphicUrl: 'https://res.cloudinary.com/honeybook/image/upload/v1557338114/system_web/home/streamlined-new-project.svg',
                            // secondaryCtaText: 'ONBOARDING.SETUP_GUIDE_STREAMLINED.MAIN_CONTENT.CREATE_PROJECT._SECONDARY_CTA_',
                            clickHandler: function clickHandler() {
                                this.NavigationService.setBackToState({
                                    name: this.$state.current.name,
                                    params: this.$state.params
                                });
                                this.EventService.createEventCommand();
                            }.bind(this)
                        },
                    },

                    // Should be `mainContent`
                    exploreItems: {
                        companyInfo: {
                            ignoreInCalc: true, //because we add an empty state in calc. consider removing the addition and not ignoring this.
                            closeSetupGuideOnClick: true,
                            fixedOrder: 1,
                            orderStreamlined: 1,
                            disableOnMobile: false,
                            headline: 'ONBOARDING.SETUP_GUIDE_STREAMLINED.MAIN_CONTENT.COMPANY_INFO._HEADLINE_',
                            bodyCopy: 'ONBOARDING.SETUP_GUIDE_STREAMLINED.MAIN_CONTENT.COMPANY_INFO._BODY_COPY_',
                            homeCardGraphicUrl: 'https://res.cloudinary.com/honeybook/image/upload/v1557338114/system_web/home/streamlined-company-info.svg',
                            // ctaText: 'ONBOARDING.SETUP_GUIDE_STREAMLINED.MAIN_CONTENT.COMPANY_INFO._CTA_',
                            // secondaryCtaText: 'ONBOARDING.SETUP_GUIDE_STREAMLINED.MAIN_CONTENT.COMPANY_INFO._SECONDARY_CTA_',
                            clickHandler: function clickHandler() {}.bind(this)
                        },

                        branding: {
                            closeSetupGuideOnClick: true,
                            homeCardOrder : 1,
                            orderStreamlined: 2,
                            disableOnMobile: false,
                            headline: 'ONBOARDING.SETUP_GUIDE_STREAMLINED.MAIN_CONTENT.CUSTOMIZE_BRAND._HEADLINE_',
                            bodyCopy: 'ONBOARDING.SETUP_GUIDE_STREAMLINED.MAIN_CONTENT.CUSTOMIZE_BRAND._BODY_COPY_',
                            graphicUrl: 'https://res.cloudinary.com/honeybook/image/upload/v1551378518/app/setup_guide_modal/Customize_illustration.svg',
                            homeCardGraphicUrl: 'https://res.cloudinary.com/honeybook/image/upload/v1557338114/system_web/home/streamlined-branding.svg',
                            ctaText: 'ONBOARDING.SETUP_GUIDE_STREAMLINED.MAIN_CONTENT.CUSTOMIZE_BRAND._CTA_',
                            hoverCtaText: 'ONBOARDING.SETUP_GUIDE_STREAMLINED.MAIN_CONTENT.CUSTOMIZE_BRAND._HOVER_CTA_',
                            secondaryCtaText: 'ONBOARDING.SETUP_GUIDE_STREAMLINED.MAIN_CONTENT.CUSTOMIZE_BRAND._SECONDARY_CTA_',
                            subtitle: 'ONBOARDING.SETUP_GUIDE_STREAMLINED.HOME_TITLES._CUSTOMIZE_BRAND_', // for home for trialers.
                            isComplete: false,
                            disableAutoCompleteTask: true, // this task does not complete on click but when user uploads.
                            clickHandler: function clickHandler() {
                                this.animateSetupGuideTopNavAfterClose();
                                this.$state.go(this.AppStates.root_core_navigation_settings_company_branding);
                            }.bind(this),
                            secondaryClickHandler: function secondaryClickHandler() {
                                var videoOptions = {
                                    videoTitle: '',
                                    videoLink: 'https://www.youtube.com/embed/Kp6kQ9Lto2o?autoplay=1&rel=0',
                                    additionalCssClasses: 'setup-guide-streamlined__video-modal',
                                };

                                return this.ModalService.openGenericVideoModal(videoOptions);
                            }.bind(this)

                        },

                        invoice: {
                            closeSetupGuideOnClick: true,
                            disableOnMobile: false,
                            orderStreamlined: 3,
                            headline: 'ONBOARDING.SETUP_GUIDE_STREAMLINED.MAIN_CONTENT.INVOICE_TEMPLATE._HEADLINE_',
                            bodyCopy: 'ONBOARDING.SETUP_GUIDE_STREAMLINED.MAIN_CONTENT.INVOICE_TEMPLATE._BODY_COPY_',
                            graphicUrl: 'https://res.cloudinary.com/honeybook/image/upload/v1527168849/app/setup_guide_modal/setup-contracts.svg',
                            homeCardGraphicUrl: 'https://res.cloudinary.com/honeybook/image/upload/v1557338114/system_web/home/streamlined-create-invoice.svg',
                            ctaText: 'ONBOARDING.SETUP_GUIDE_STREAMLINED.MAIN_CONTENT.INVOICE_TEMPLATE._CTA_',
                            hoverCtaText: 'ONBOARDING.SETUP_GUIDE_STREAMLINED.MAIN_CONTENT.INVOICE_TEMPLATE._HOVER_CTA_',
                            secondaryCtaText: 'ONBOARDING.SETUP_GUIDE_STREAMLINED.MAIN_CONTENT.INVOICE_TEMPLATE._SECONDARY_CTA_',
                            clickHandler: function clickHandler() {
                                this.AbTestService.convertAbTest(this.Enums.ABTests.onboardingSetupGuideHome);
                                this._setItemAsLoading('invoice', true);
                                this.startInvoiceTemplateFlow()
                                .then( function success(res) {
                                    // $timeout allows the UI to navigate before
                                    // the loader goes away.
                                    this.$timeout( function () {
                                        this._setItemAsLoading('invoice', false);
                                    }.bind(this), 1000);
                                }.bind(this),
                                function failure(res) {
                                    this._setItemAsLoading('clientSide', false);
                                }.bind(this));

                            }.bind(this),
                            secondaryClickHandler: function secondaryClickHandler() {
                                var videoOptions = {
                                    videoTitle: '',
                                    videoLink: 'https://www.youtube.com/embed/BTwra7r7Dlo?autoplay=1&rel=0',
                                    additionalCssClasses: 'setup-guide-streamlined__video-modal',
                                };

                                return this.ModalService.openGenericVideoModal(videoOptions);
                            }.bind(this)
                        },

                        clientSide: {
                            closeSetupGuideOnClick: true,
                            disableOnMobile: false,
                            orderStreamlined: 4,
                            headline: 'ONBOARDING.SETUP_GUIDE_STREAMLINED.MAIN_CONTENT.CLIENT_EXPERIENCE._HEADLINE_',
                            bodyCopy: this.clientSideBodyCopy,
                            graphicUrl: 'https://res.cloudinary.com/honeybook/image/upload/v1551378581/app/setup_guide_modal/preview_illustration.svg',
                            homeCardGraphicUrl: 'https://res.cloudinary.com/honeybook/image/upload/v1557338489/system_web/home/streamlined-preview-client.svg',
                            ctaText: 'ONBOARDING.SETUP_GUIDE_STREAMLINED.MAIN_CONTENT.CLIENT_EXPERIENCE._CTA_',
                            hoverCtaText: 'ONBOARDING.SETUP_GUIDE_STREAMLINED.MAIN_CONTENT.CLIENT_EXPERIENCE._HOVER_CTA_',
                            secondaryCtaText: 'ONBOARDING.SETUP_GUIDE_STREAMLINED.MAIN_CONTENT.CLIENT_EXPERIENCE._SECONDARY_CTA_',
                            image: '//res.cloudinary.com/honeybook/image/upload/v1527168848/app/setup_guide_modal/setup-client.svg',
                            clickHandler: function clickHandler() {
                                this._setItemAsLoading('clientSide', true);
                                // this.createExampleProposal();
                                this.startClientExperienceFlow(this.clientSideFileType)
                                .then( function success(res) {
                                    // $timeout allows the UI to navigate before
                                    // the loader goes away.
                                    this.$timeout( function () {
                                        this._setItemAsLoading('clientSide', false);
                                    }.bind(this), 1000);
                                }.bind(this),
                                function failure(res) {
                                    this._setItemAsLoading('clientSide', false);
                                }.bind(this));
                               // this.PopupMessageService.showAlert(this.PopupMessageService.severityTypes.info, 'Here’s a preview of what your client will see. We also sent you the same example via email.', null, 'View proposal as client');
                            }.bind(this),
                            secondaryClickHandler: function secondaryClickHandler() {
                                var videoOptions = {
                                    videoTitle: '',
                                    videoLink: 'https://www.youtube.com/embed/Wm8XtR8_-oI?autoplay=1&rel=0',
                                    additionalCssClasses: 'setup-guide-streamlined__video-modal',
                                };

                                return this.ModalService.openGenericVideoModal(videoOptions);
                            }.bind(this)
                        },
                    },

                    // Should be `secondaryContent`
                    customizeItems: {

                        clientBot: {
                            homeCardOrder : 2,
                            ignoreInCalc: true,
                            closeSetupGuideOnClick: true,
                            disableOnMobile: false,
                            title: 'ONBOARDING.SETUP_GUIDE_STREAMLINED.SECONDARY_CONTENT._CLIENTBOT_',
                            subtitle: 'ONBOARDING.SETUP_GUIDE_STREAMLINED.HOME_TITLES._CLIENT_BOT_', // for home for trialers.
                            clickHandler: function clickHandler() {
                                this._setItemAsLoading('clientBot', true);
                                this.ModalService.openCreateFirstProjectModal(true).finally(function () {
                                    this._setItemAsLoading('clientBot', false);
                                }.bind(this));
                            }.bind(this)
                        },

                        pipeline: {
                            homeCardOrder : 3,
                            ignoreInCalc: true,
                            closeSetupGuideOnClick: true,
                            disableOnMobile: true,
                            title: 'ONBOARDING.SETUP_GUIDE_STREAMLINED.SECONDARY_CONTENT._PIPELINE_',
                            subtitle: 'ONBOARDING.SETUP_GUIDE_STREAMLINED.HOME_TITLES._PIPELINE_', // for home for trialers.
                            hideFromHome: true,
                            clickHandler: function clickHandler() {
                                this.$state.go(this.AppStates.root_core_navigation_pipeline, {showFeatureOnboarding: true});
                            }.bind(this)
                        },

                        demoAccount: {
                            ignoreInCalc: true,
                            disableOnMobile: false,
                            title: 'ONBOARDING.SETUP_GUIDE_STREAMLINED.SECONDARY_CONTENT._BUILD_OUT_ACCOUNT_',
                            image: '//res.cloudinary.com/honeybook/image/upload/v1527168848/app/setup_guide_modal/setup-full-account.svg',
                            clickHandler: function clickHandler() {
                                this.handleDemoAccountClick();
                            }.bind(this)
                        },

                        accountSetup: {
                            ignoreInCalc: true,
                            disableOnMobile: false,
                            title: 'ONBOARDING.SETUP_GUIDE_STREAMLINED.SECONDARY_CONTENT._ACCOUNT_SETUP_',
                            clickHandler: function clickHandler() {
                                this.AnalyticsService.trackClick(this, "account setup offer accepted", {source: "setup guide"});
                                this.$state.go(this.AppStates.root_core_accountSetup);
                            }.bind(this)
                        },

                    }
                };

                var stepsArray = this._.map(this._setupGuideRawData, function (list, listKey) {
                    return this._.map(list, function (item, itemKey) {
                        var clonedItem = this._.clone(item);
                        return this._.extend(clonedItem, {
                            key: itemKey,
                            listKey: listKey,
                            isComplete: false,
                            isLoading: false,
                        })
                    }.bind(this))
                }.bind(this));

                var concatedArrays = [];
                this._.each(stepsArray, function (array) {
                    concatedArrays = concatedArrays.concat(array);
                });
                return concatedArrays;

            },


            _getSetupGuideCompletedSteps: function _getSetupGuideCompletedSteps() {
                var completed_steps_names = [];
                if (this.currUser.onboarding_container && this.currUser.onboarding_container.setup_guide) {
                    var completed_steps =  this.currUser.onboarding_container.setup_guide.setup_guide_completed_steps;
                    completed_steps_names = this._.map(completed_steps, function (step) {
                        return step.name;
                    }.bind(this));
                }
               return completed_steps_names;
            },

            _setItemAsLoading: function _setItemAsLoading(key, isLoading) {

                var step = _.find(this.steps, function (step) {
                    return step.key === key
                });
                if (step) {
                    step.isLoading = isLoading;
                }
            },

            initializeSetupGuideService: function initializeSetupGuideService() {
                this.currUser = this.UsersManager.getCurrUser();
                if (this.currUser.isClient()) {
                    return;
                }
                this.initSetupGuide();
                this.getSteps();
            },

            initSetupGuide: function initSetupGuide() {
                var variation = this.getSetupGuideTestVariation();

                this.initSetupGuideFileTypeTest();
                this.setupGuideType = variation;
            },

            getStepsInner: function getStepsInner() {
                if (this.setupGuideType === this.setupGuideVersionNames.v3 || this.setupGuideType === this.setupGuideVersionNames.v4) {
                    this.steps = this.getSetupGuideStreamlinedSteps();
                } else {
                    this.steps = this._getSetupGuideStepsModal();
                }

                this.markStepsAsCompleted();
                this.calcCompletionPercentage();
                this.trigger('SetupGuideStepsUpdated');
            },

            initSetupGuideFileTypeTest: function() {
                this.clientSideFileType = 'proposal';
                this.clientSideBodyCopy = this.$translate.instant('ONBOARDING.SETUP_GUIDE_STREAMLINED.MAIN_CONTENT.CLIENT_EXPERIENCE._BODY_COPY_PROPOSAL_');

                if (!this.FeaturesService.startedOnboardingAfterFeature(this.currUser, this.FeaturesService.features.streamlinedInvoiceVsProposal)) {
                    //old trialers get proposal and dont go into abtest
                    return;
                }

                var streamlinedFileType = this.currUser.getExistingAbTestVariation(this.Enums.ABTests.streamlinedInvoiceVsProposal);
                if (streamlinedFileType === 'invoice') {
                    this.clientSideFileType = 'invoice';
                    this.clientSideBodyCopy = this.$translate.instant('ONBOARDING.SETUP_GUIDE_STREAMLINED.MAIN_CONTENT.CLIENT_EXPERIENCE._BODY_COPY_INVOICE_');
                }
            },

            getSteps: function getSteps() {
                if (this.setupGuideType === undefined) {
                    this.initSetupGuide();
                    this.getStepsInner();
                }
                else {
                    this.getStepsInner();
                }
            },

            markStepsAsCompleted: function markStepsAsCompleted() {
                // look over and update completion
                this.setupGuideCompletedSteps = this._getSetupGuideCompletedSteps();
                this.steps.forEach(function (step) {
                    step.isComplete = !!(this.setupGuideCompletedSteps && (this.setupGuideCompletedSteps.indexOf(step.key) > -1));
                }.bind(this));
            },

            handleDemoAccountClick: function handleDemoAccountClick() {
                if (!this.galleryInitialized) {
                    this.JsSlicklightboxService.init(this.demo_assets, this.lightboxContainer);

                    this.JsSlicklightboxService.on(this.JsSlicklightboxService.LIGHTBOX_HIDDEN, this.onLightboxHidden.bind(this));
                    this.JsSlicklightboxService.on(this.JsSlicklightboxService.LIGHTBOX_SHOWN, this.onLightboxShown.bind(this));
                    this.JsSlicklightboxService.on(this.JsSlicklightboxService.LIGHTBOX_IMAGE_CHANGE, this.onLightboxImageChanged.bind(this));

                    this.galleryInitialized = true;
                }


                this.JsSlicklightboxService.show();
            },

            completeStep: function completeStep(step) {
                if (!step.isComplete) {

                    // set complete on step
                    step.isComplete = true;

                    // update ui persistency
                    this._persistCompletedStep(step);

                    //update setup guide completion
                    this.calcCompletionPercentage();

                    // trigger event
                    this._triggerCompletedEvent(step);
                }
            },

            completeStepByKey: function completeStepByKey(stepKey) {
                var step = this.getStepByKey(stepKey);
                if (step) {
                    this.completeStep(step);
                }
            },

            getStepByKey: function getStepByKey(stepKey) {
                var step = _.find(this.steps, function (step) {
                    return step.key === stepKey;
                });
                return step;
            },

            calcCompletionPercentage: function calcCompletionPercentage() {
                var stepsToNotIgnore = this.steps.filter(function(step) { return !step.ignoreInCalc });

                // starts with 1 step complete
                var totalSteps = stepsToNotIgnore.length + 1;

                // maximum completion is 99%
                var piePerStep = 1 / totalSteps * (100 - this._subscriptionPercent);

                var stepsCompleted = stepsToNotIgnore.filter(function (step) {
                    return step.isComplete;
                });

                // adds 1% (or 9%, depends on this._subscriptionPercent) for subscription
                var subscribedPie = this.currUser.companyHasSubscription() ? this._subscriptionPercent : 0;

                this.setupGuideStats.completion = Math.floor((stepsCompleted.length + 1) * piePerStep + subscribedPie);
            },


            // lightbox test
            onLightboxShown: function onLightboxShown(event) {
                if (event.container === this.lightboxContainer) {
                    this.AnalyticsService.track(this, 'demo_account_test', {stage: 'galley', action: 'opened'});
                }
            },

            onLightboxHidden: function onLightboxHidden(event) {
                // add ui only show once?
                if (event.container === this.lightboxContainer) {
                    this.AnalyticsService.track(this, 'demo_account_test', {stage: 'galley', action: 'closed'});
                    this.openFirstQuestion();
                }
            },

            openFirstQuestion: function openFirstQuestion() {
                this.PopupMessageService.showConfirm(this.PopupMessageService.severityTypes.info,
                    'ONBOARDING.SETUP_GUIDE.STEPS.DEMO._LIKE_TO_TRY_',
                    function () {
                        // this.PopupMessageService.clearPopup();

                        this.$timeout(function () {
                            this.openSecondQuestion();
                        }.bind(this), 50);

                        this.AnalyticsService.track(this, 'demo_account_test', {
                            stage: 'first_question',
                            action: 'select_yes'
                        })
                    }.bind(this),
                    function () {
                        this.AnalyticsService.track(this, 'demo_account_test', {
                            stage: 'first_question',
                            action: 'dismiss'
                        })
                    }.bind(this),
                    'ONBOARDING.SETUP_GUIDE.STEPS.DEMO._LIKE_TO_TRY_YES_',
                    'ONBOARDING.SETUP_GUIDE.STEPS.DEMO._LIKE_TO_TRY_NO_');
            },

            openSecondQuestion: function openFirstQuestion() {
                var isCompanySubscribed = this.OnboardingService.isUserSubscribed();

                this.PopupMessageService.showConfirm(this.PopupMessageService.severityTypes.info,
                    isCompanySubscribed ? 'ONBOARDING.SETUP_GUIDE.STEPS.DEMO._SCHEDULE_WEBINAR_' : 'ONBOARDING.SETUP_GUIDE.STEPS.DEMO._SCHEDULE_DEMO_',
                    function () {
                        isCompanySubscribed ? this.openWebinarPage() : this.openCalendly();
                        this.AnalyticsService.track(this, 'demo_account_test', {
                            stage: 'second_question',
                            action: 'select_yes',
                            is_subscribed: isCompanySubscribed
                        });
                    }.bind(this),
                    function () {
                        this.AnalyticsService.track(this, 'demo_account_test', {
                            stage: 'second_question',
                            action: 'select_no',
                            is_subscribed: isCompanySubscribed
                        })
                    }.bind(this),
                    isCompanySubscribed ? 'ONBOARDING.SETUP_GUIDE.STEPS.DEMO._SCHEDULE_WEBINAR_YES_' : 'ONBOARDING.SETUP_GUIDE.STEPS.DEMO._SCHEDULE_DEMO_YES_',
                    isCompanySubscribed ? 'ONBOARDING.SETUP_GUIDE.STEPS.DEMO._SCHEDULE_WEBINAR_NO_' : 'ONBOARDING.SETUP_GUIDE.STEPS.DEMO._SCHEDULE_DEMO_NO_');
            },

            openWebinarPage: function openWebinarPage() {
                var otherWindow = this.$window.open();
                otherWindow.opener = null;
                otherWindow.location = "https://www.honeybook.com/product-education";
            },

            openCalendly: function openCalendly() {
                this.AnalyticsService.track(this, 'demo_account_test', {stage: 'calendly_opened'});
                this.UserService.openAECalendlyLink(this.currUser);

            },

            onLightboxImageChanged: function onLightboxImageChanged(event) {
                if (event.container === this.lightboxContainer) {
                    this.AnalyticsService.track(this, 'demo_account_test', {stage: 'galley', action: 'image_changed'});
                }
            },


            userStartedOnboardingAfterSetupGuideDemoAccountTest: function userStartedOnboardingAfterSetupGuideDemoAccountTest() {
                return this.FeaturesService.startedOnboardingAfterFeature(
                    this.currUser, this.FeaturesService.features.setupGuideDemoAccount
                );
            },

            _persistCompletedStep: function (step) {
                this.SelfOnboardingManager.completeSetupGuideStep(this.currUser ,step.key, this.setupGuideType);

            },

            _triggerCompletedEvent: function _triggerCompletedEvent(step) {
                this.trigger(this.STEP_COMPLETED_EVENT_NAME, {
                    step: step
                });
            },

            createExampleProposal: function createExampleProposal() {
                if (this.requestInProgress) {
                    return;
                }
                this.requestInProgress = true;

                this.UserService.createExampleProposal().finally(function () {
                    this.requestInProgress = false;
                    this._setItemAsLoading('clientSide', false);
                }.bind(this));
            },

            getSetupGuideTestVariation: function getSetupGuideTestVariation() {
                var setupGuideHomeVsModalVariation = this.currUser.getExistingAbTestVariation(this.Enums.ABTests.onboardingSetupGuideHome);
                if (setupGuideHomeVsModalVariation === 'streamlined_dark') {
                    return this.setupGuideVersionNames.v3;
                }
                else {
                     return this.setupGuideVersionNames.v4; //HOME is currently the default.
                }
            },

            isSetupGuideActiveForTrialers: function isSetupGuideActiveForTrialers() {

                this.currUser = this.UsersManager.getCurrUser();
                var isPreTrialer = this.currUser.shouldStartTrial();
                var isUserSubscribed = this.currUser.companyHasSubscription() && this.currUser.company.account.pricing_plan;
                var timeToStop = isUserSubscribed ? this.moment(this.currUser.company.account.pricing_plan.plan_start_date).add(14, 'days') : null;
                var ui_persistencyCompleted = this.UiPersistenceService.getUiPersistence(this.UiPersistenceService.keys.setupGuideCompletedAllSteps, {allStepsCompleted: false}).allStepsCompleted;

                var isSetupGuideCompleted = this.isSetupGuideCompleted() || ui_persistencyCompleted;
                return !isSetupGuideCompleted && !isPreTrialer && (!isUserSubscribed || this.moment().isBefore(timeToStop));
            },

            isSetupGuideActiveForSubscribedUsers: function isSetupGuideActiveForSubscribedUsers() {
                this.currUser = this.UsersManager.getCurrUser();

                var isSetupGuideCompleted = this.isSetupGuideCompleted();
                var isCompanySubscribed = this.currUser.companyHasSubscription();
                var isStartedOnboardingAfterJan2019 = this.currUser.startedTrialAfterDate('2019-01-01');

                return (isCompanySubscribed && !isSetupGuideCompleted && isStartedOnboardingAfterJan2019);
            },

            isAccountSetupShown: function isAccountSetupShown() {
                var isSetupGuideCompleted = this.isSetupGuideCompleted();
                var isCompanySubscribed = this.currUser.companyHasSubscription();
                var isStartedOnboardingAfterJan2019 = this.currUser.startedTrialAfterDate('2019-01-01');
                var isUserActivated = this.currUser.isActivated();
                var isShowAccountSetup = this.currUser.company && this.currUser.company.offer_account_setup  && this.currUser.isCompanyOwner();

                return (isCompanySubscribed && isSetupGuideCompleted && isStartedOnboardingAfterJan2019 && !isUserActivated && isShowAccountSetup)
            },

            isSetupGuideCompleted: function isSetupGuideCompleted() {
                return (this.setupGuideStats.completion === 100);
            },

            isSetupGuideActive: function isSetupGuideActive() {
                return (this.isSetupGuideActiveForSubscribedUsers() || this.isSetupGuideActiveForTrialers());
            },

            shareasaleGetCookie: function shareasaleGetCookie(e) {
                var r = e + "=";
                var a = decodeURIComponent(document.cookie);
                var o = a.split(";");
                for (var n = 0; n < o.length; n++) {
                    var t = o[n];
                    while (t.charAt(0) === " ") {
                        t = t.substring(1);
                    }
                    if (t.indexOf(r) === 0) {
                        return t.substring(r.length, t.length);
                    }
                }
                return "";
            },

            showShareasalePixel: function showShareasalePixel(user) {
                var show = false;
                if (user.attribution && user.attribution.user_source_signup === 'affiliate') {
                    show = this.UiPersistenceService.getUiPersistence(this.UiPersistenceService.keys.shareasalePixel, {show: true}).show;
                    if (show) {
                        this.UiPersistenceService.setUiPersistence(this.UiPersistenceService.keys.shareasalePixel, {show: false});
                    }
                }

                return show;
            },

            checkIfCompanyHasLogo: function checkIfCompanyHasLogo() {
                if (!this.currUser.company.isDefaultCompanyIcon()){
                    var step = this.getStepByKey('branding');
                    if (step && !step.isComplete && this.isSetupGuideActive()) {
                        this.completeStep(step);
                    }
                }
            },

            completeCreateProjectTask: function completeCreateProjectTask() {
                var step = this.getStepByKey('createProject');
                if (step && !step.isComplete && this.isSetupGuideActive()) {
                    this.completeStep(step);
                }
            },

            startInvoiceTemplateFlow: function startInvoiceTemplateFlow() {

                return this.SelfOnboardingManager.createOnboardingInvoiceTemplate().then( function(ret){
                    if (ret.data &&  ret.data.template_id) {
                        var templateId = ret.data.template_id;

                        //mixin the templates, another api call.
                        this.TemplatesManager.getInvoice(this.currUser.company, this.currUser, templateId).then(function () {
                            this.TemplatesViewService.goToTemplatesEditor('invoice', templateId);
                        }.bind(this));
                    }
                }.bind(this));
            },

            startClientExperienceFlow: function startClientExperienceFlow(fileType) {

                return this.SelfOnboardingManager.createOnboardingProjectAndFile(this.currUser, this.currUser.company, fileType).then( function(ret){
                    if (ret.data &&  ret.data.file_id) {
                        this.WorkspaceFileService.gotoWorkspaceFileById(ret.data.file_id, true, {isOnboardingInvoiceMode: false,
                                                                                                     showClientPreviewModal: true,
                                                                                                     shouldExplicitlyExitPreviewtoEditFile:true },
                                                                                                     false);
                    }
                }.bind(this));
            },

            animateSetupGuideTopNavAfterClose: function animateSetupGuideTopNavAfterClose() {
                var shouldAnimate = this.UiPersistenceService.getUiPersistence(this.UiPersistenceService.keys.setupGuideTopNavAnimate, {shouldAnimate: true}).shouldAnimate;
                if (shouldAnimate) {
                    this.setupGuideTopNavAnimationActive = true;
                    this.$timeout( function () {
                        this.setupGuideTopNavAnimationActive = false;
                    }.bind(this), 5000);
                }
            },

            stopAnimateSetupGuideTopNavAfterClose: function stopAnimateSetupGuideTopNavAfterClose() {
                this.UiPersistenceService.setUiPersistence(
                    this.UiPersistenceService.keys.setupGuideTopNavAnimate,
                    {shouldAnimate: false});
            },

            getPersistenceHomeOnboardingCard: function getPersistenceHomeOnboardingCard() {
                return this.UiPersistenceService.getUiPersistence(
                    this.UiPersistenceService.keys.homeOnboardingCard,
                    {
                        isCollapsed: false,
                        hasSeenCreateProjectPopover: false,
                        hasSeenSubscribeHerePopover: false,
                        hasMarkedComplete: false,
                        hasClickedCompleteMwebWizard: false,
                    }
                );
            },

            setPersistenceHomeOnboardingCard: function setPersistenceHomeOnboardingCard(hash) {
                var homeOnboardingCardPersistence =
                    this.getPersistenceHomeOnboardingCard();

                var updatedPersistence = this._.extend(
                    homeOnboardingCardPersistence,
                    hash
                );

                this.UiPersistenceService.setUiPersistence(
                    this.UiPersistenceService.keys.homeOnboardingCard,
                    updatedPersistence
                );
            },

            getNextStreamlinedStep: function getNextStreamlinedStep() {
                if (this.setupGuideType === this.setupGuideVersionNames.v3
                    || this.setupGuideType === this.setupGuideVersionNames.v4) {
                    // orderStreamlined:
                    // companyInfo, branding, invoice, clientSide, createProject, becomeMember
                    //
                    // In this function, we filter for only the ordered steps,
                    // sort by their given value, and find the first incomplete step
                    var nextStep = this._.chain(this.steps)
                        .filter(function(step){ return step.orderStreamlined })
                        .sortBy(function(step){ return step.orderStreamlined })
                        .find(function(step){ return !step.isComplete })
                        .value();

                    // If nextStep === undefined, default to the last step (becomeMember)
                    return nextStep || this.steps.find(function(step){ return step.key === 'becomeMember' });
                }
                // If they're not in the streamlined test, next step isn't defined
                return undefined;
            },

            isStreamlinedCreateProjectStepActive: function isStreamlinedCreateProjectStepActive() {
                var nextStep = this.getNextStreamlinedStep();
                var createProjectStep = this.getStepByKey('createProject');

                return this._.isEqual(nextStep, createProjectStep);
            },

            isNextStreamlinedStep: function isNextStreamlinedStep(key) {
                var nextStep = this.getNextStreamlinedStep();

                return (nextStep && key ? nextStep.key === key : false)
            },

            animateCreateEvent: function animateCreateEvent() {
                this.createEventIsAnimating = true;
                this.$timeout(function () {
                    this.createEventIsAnimating = false;
                }.bind(this), 5000);
            },

        };
    });
}());
